// Seleciona o modal e a imagem de tela cheia
const fullscreenView = document.getElementById("fullscreenView");
const fullscreenImage = document.getElementById("fullscreenImage");
const galleryItems = document.querySelectorAll(".carousel-slide img");
const btnPrev = document.getElementById("btnPrevFull");
const btnNext = document.getElementById("btnNextFull");

// Variável para rastrear o estado de zoom
let isZoomed = false;

// Variável para rastrear a imagem atual
let currentIndexGallery = 0;

let isDragging = false; // Estado de arrasto

let startX, startY, scrollLeft, scrollTop; // Variáveis para rastrear movimento

const scrollContainer = document.querySelector(".scroll-container");

let currentSlide = 0;

function moveSlide(direction) {
  const track = document.querySelector(".carousel-track");
  const slides = document.querySelectorAll(".carousel-slide");
  const totalSlides = slides.length;
  const visibleSlides = window.innerWidth <= 768 ? 2 : 3;
  const maxSlideIndex = totalSlides - visibleSlides;

  currentSlide += direction;

  if (currentSlide < 0) {
    currentSlide = maxSlideIndex;
  } else if (currentSlide > maxSlideIndex) {
    currentSlide = 0;
  }

  track.style.transform = `translateX(-${157 * currentSlide}px)`;
}

function changeMainImage(newImage) {
  const imagem = document.getElementById("main-image");

  if (imagem) {
    imagem.src = newImage;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const accordionButtons = document.querySelectorAll(".accordion-button");

  accordionButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const accordionItem = this.closest(".accordion-item");
      const sizeSpan = document.querySelector(".size-span");

      // Verifica se o botão está expandido
      if (this.getAttribute("aria-expanded") === "true") {
        accordionItem.classList.add("border-active");
        if (button.id == "size") {
          sizeSpan.classList.add("d-block");
          sizeSpan.classList.remove("d-none");
        }
      } else {
        accordionItem.classList.remove("border-active");
        if (button.id == "size") {
          sizeSpan.classList.add("d-none");
          sizeSpan.classList.remove("d-block");
        }
      }
    });
  });
});

document.getElementById("main-image").addEventListener("click", function () {
  // Sua lógica aqui
  isZoomed = false;
  fullscreenImage.src = document.getElementById("main-image").src; // Define a imagem de tela cheia
  fullscreenView.classList.add("active"); // Mostra o modal
  fullscreenImage.style.transform = ""; // Remove o zoom
  scrollContainer.style.overflow = "hidden"; // Desabilita o scroll
  fullscreenImage.style.imageRendering = ""; // Reseta a qualidade da imagem
  scrollContainer.classList.remove("zoomed"); // Remove a classe de zoom
  btnClose.classList.remove("hidden");
  btnPrev.classList.remove("hidden");
  btnNext.classList.remove("hidden");
});

// Fecha o modal ao clicar fora da imagem ou ao pressionar "Esc"
fullscreenView.addEventListener("click", (e) => {
  if (e.target !== fullscreenImage) {
    fullscreenView.classList.remove("active"); // Oculta o modal
    isZoomed = false; // Reseta o estado de zoom ao fechar
  }
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    fullscreenView.classList.remove("active"); // Oculta o modal
    isZoomed = false; // Reseta o estado de zoom ao fechar
  }
});

const btnClose = document.getElementById("btn-close");
btnClose.addEventListener("click", () => {
  fullscreenView.classList.remove("active"); // Oculta o modal
  isZoomed = false; // Reseta o estado de zoom ao fechar
  isZoomed = false;
  fullscreenImage.classList.remove("  ");
  btnClose.classList.remove("hidden");
  btnPrev.classList.remove("hidden");
  btnNext.classList.remove("hidden");
});

// Função para atualizar a imagem de tela cheia
function showFullscreenImage(index) {
  currentIndexGallery = index;
  fullscreenImage.src = galleryItems[currentIndexGallery].src;
  fullscreenView.classList.add("active");
}

// Fecha o modal ao clicar fora da imagem ou ao pressionar "Esc"
fullscreenView.addEventListener("click", (e) => {
  if (
    e.target !== fullscreenImage &&
    e.target !== btnPrev &&
    e.target !== btnNext
  ) {
    fullscreenView.classList.remove("active");
    isZoomed = false;
    fullscreenImage.classList.remove("  ");
    btnClose.classList.remove("hidden");
    btnPrev.classList.remove("hidden");
    btnNext.classList.remove("hidden");
  }
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    fullscreenView.classList.remove("active");
    isZoomed = false;
    fullscreenImage.classList.remove("  ");
    btnClose.classList.remove("hidden");
    btnPrev.classList.remove("hidden");
    btnNext.classList.remove("hidden");
  }
});

// Alterna o zoom ao clicar na imagem
fullscreenImage.addEventListener("click", () => {
  if (!isZoomed) {
    // Ativa o zoom
    isZoomed = true;
    fullscreenImage.style.transform = "scale(2)"; // Aplica o zoom
    scrollContainer.style.overflow = "auto"; // Habilita o scroll
    scrollContainer.classList.add("zoomed");
    btnClose.classList.add("hidden"); // Oculta o botão de fechar
    btnNext.classList.add("hidden");
    btnPrev.classList.add("hidden");
  } else {
    // Sai do zoom
    isZoomed = false;
    fullscreenImage.style.transform = ""; // Remove o zoom
    scrollContainer.style.overflow = "hidden"; // Desabilita o scroll
    fullscreenImage.style.imageRendering = ""; // Reseta a qualidade da imagem
    scrollContainer.classList.remove("zoomed"); // Remove a classe de zoom
    btnClose.classList.remove("hidden"); // Mostra o botão de fechar
    btnNext.classList.remove("hidden");
    btnPrev.classList.remove("hidden");
  }
});

// Reseta o zoom
function resetZoom() {
  isZoomed = false;
  fullscreenImage.classList.remove("  ");
  btnClose.classList.remove("hidden");
  btnPrev.classList.remove("hidden");
  btnNext.classList.remove("hidden");
}

// Previne o comportamento padrão de arrastar a imagem
fullscreenImage.addEventListener("dragstart", (e) => {
  e.preventDefault(); // Bloqueia o arraste padrão
});

// Evento ao pressionar o mouse (inicia o arrasto)
scrollContainer.addEventListener("mousedown", (e) => {
  if (!isZoomed) return; // Só ativa arrasto se estiver no zoom
  e.preventDefault(); // Bloqueia o comportamento padrão
  isDragging = true; // Inicia o estado de arrasto
  startX = e.pageX - scrollContainer.offsetLeft; // Posição inicial X
  startY = e.pageY - scrollContainer.offsetTop; // Posição inicial Y
  scrollLeft = scrollContainer.scrollLeft; // Posição de scroll horizontal inicial
  scrollTop = scrollContainer.scrollTop; // Posição de scroll vertical inicial
  scrollContainer.style.cursor = "grabbing"; // Altera o cursor
});

// Evento ao mover o mouse (durante o arrasto)
scrollContainer.addEventListener("mousemove", (e) => {
  if (!isDragging || !isZoomed) return; // Só permite mover se estiver arrastando e no zoom
  e.preventDefault(); // Bloqueia o comportamento padrão
  const x = e.pageX - scrollContainer.offsetLeft; // Posição atual X
  const y = e.pageY - scrollContainer.offsetTop; // Posição atual Y
  const walkX = (x - startX) * 1.5; // Calcula a distância percorrida no X
  const walkY = (y - startY) * 1.5; // Calcula a distância percorrida no Y
  scrollContainer.scrollLeft = scrollLeft - walkX; // Atualiza o scroll horizontal
  scrollContainer.scrollTop = scrollTop - walkY; // Atualiza o scroll vertical
});

// Evento ao soltar o mouse (encerra o arrasto)
scrollContainer.addEventListener("mouseup", () => {
  isDragging = false; // Encerra o arrasto
  if (isZoomed) {
    scrollContainer.style.cursor = "grab"; // Volta o cursor para "grab"
  }
});

// Garante que o arrasto encerre se o cursor sair do contêiner
scrollContainer.addEventListener("mouseleave", () => {
  isDragging = false; // Encerra o arrasto
  if (isZoomed) {
    scrollContainer.style.cursor = "grab"; // Volta o cursor para "grab"
  }
});

// Função para navegar para a próxima imagem
function showNextImage() {
  currentIndexGallery = (currentIndexGallery + 1) % galleryItems.length;
  showFullscreenImage(currentIndexGallery);
  resetZoom();
}

// Função para navegar para a imagem anterior
function showPrevImage() {
  currentIndexGallery =
    (currentIndexGallery - 1 + galleryItems.length) % galleryItems.length;
  showFullscreenImage(currentIndexGallery);
  resetZoom();
}

// Eventos de clique para as setas de navegação
btnNext.addEventListener("click", (e) => {
  e.stopPropagation(); // Evita fechar o modal ao clicar nas setas
  showNextImage();
});

btnPrev.addEventListener("click", (e) => {
  e.stopPropagation();
  showPrevImage();
});
